import React, { Fragment } from 'react';
import { IconArrowUpBold } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';
import { GetPdpIntegratedData_pdp_base_info_policy_list } from '@domains/pdp-common';

export type BoxStatus = { [key: string]: boolean };

interface Props {
  policyList: GetPdpIntegratedData_pdp_base_info_policy_list[];
  policyListOpenStatus: BoxStatus;
  handleBoxClick: (key: string) => void;
}

export const PolicyList: React.FC<React.PropsWithChildren<Props>> = ({ policyList, policyListOpenStatus, handleBoxClick }) => {
  return (
    <>
      {policyList.map(({ main_title, content_list }) => {
        const isOpened = policyListOpenStatus[main_title];
        return (
          <div key={main_title}>
            <Divider />
            <Section isOpened={isOpened} onClick={() => handleBoxClick(main_title)}>
              <SectionTitle className={Typography.BODY_16_SEMIBOLD}>
                {main_title}
                <IconArrowUpBold v3Color='gray950' width={24} height={24} className='icon' />
              </SectionTitle>
              {isOpened &&
                content_list.map(({ title, description }, index) => (
                  <Fragment key={description}>
                    {title && (
                      <PolicySubtitle isFirst={index === 0} className={Typography.CAPTION_12_MEDIUM}>
                        {title}
                      </PolicySubtitle>
                    )}
                    <PolicyContent dangerouslySetInnerHTML={{ __html: description }} />
                  </Fragment>
                ))}
            </Section>
          </div>
        );
      })}
    </>
  );
};

const Divider = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${vars.v3Color.gray100};
`;

const Section = styled.section<{ isOpened?: boolean }>`
  position: relative;
  padding: 0 16px;

  .icon {
    position: absolute;
    right: 12px;
    transform: rotate(180deg);
  }

  ${({ isOpened }) =>
    isOpened &&
    css`
      padding: 0 16px 16px;

      .icon {
        transform: rotate(0deg);
      }
    `}
`;

const SectionTitle = styled.p`
  display: flex;
  align-items: center;
  height: 48px;
`;

const PolicySubtitle = styled.p<{ isFirst: boolean }>`
  margin: ${({ isFirst }) => (isFirst ? '8px 0 12px 0' : '24px 0 12px 0')};
  display: flex;
  align-items: center;
  height: 14px;
  line-height: 16px;
  color: ${vars.v3Color.gray700};
`;

const PolicyContent = styled.div`
  margin: 8px 0 0 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: ${vars.v3Color.gray500};
`;
